<template>
  <div class="ui-table-info-row">
    <slot></slot>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss">
@import '../styles/config';

.ui-table-info-row {
  display: flex;
  border-bottom: 1px solid $gray-200;

  &:first-child {
    border-top: 1px solid $gray-200;
  }

  .ui-table-info-cell {
    flex: 1 1 0%;
  }
}
</style>
